import React, { useEffect } from "react";
import "./Show_Programs_Modal.css";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import Pink_Btn from "../../common_btn/pink_btn/Pink_Btn";
import Orange_Btn from "../../common_btn/orange_btn/Orange_Btn";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AllCountry, AllState } from "../../../../features/admin/common/Slice";

const Show_Programs_Modal = (props) => {
  const {
    control,
    reset,
    register,
    setValue, watch,
    handleSubmit,
    formState: { errors },
  } = useForm();

  // const countries = [
  //   { value: "chocolate", label: "Chocolate" },
  //   { value: "strawberry", label: "Strawberry" },
  //   { value: "vanilla", label: "Vanilla" },
  // ];


  const navigate = useNavigate()
  const dispatch = useDispatch();
  const countries = useSelector((state) => state.common.all_country);
  const states = useSelector((state) => state.common.all_state);

  useEffect(() => {
    dispatch(AllCountry());
  }, [dispatch]);

  console.log(watch(), "pppppajsd");

  const onSubmit = (data) => {
    navigate("/near-by-events", {
      state: {
        country_id: data.country_id,
        state_id: data.state_id,
      },
    });

    props.onHide?.(); // close modal if needed
  };

  return (
    <>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="common_modal Show_Programs_Modal"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Please choose nearest location in order to see programs in your area
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>

          <Form className="program_form">
            <div className="from-group">
              <Form.Label>Country Of Residence*</Form.Label>
              <Controller
                className="Select_Dropdown_holder"
                name="country_id"
                control={control}
                // rules={{ required: "Country is required" }}
                render={({ field }) => (
                  <Select
                    styles={{
                      control: (baseStyles) => ({
                        ...baseStyles,
                        borderColor: errors.country_id ? "red" : baseStyles,
                      }),
                    }}
                    {...field}
                    options={countries}
                    onChange={(selectedOption) => {
                      field.onChange(selectedOption);
                      setValue("state_id", null);
                      dispatch(AllState({ countryId: selectedOption.value }));
                    }}
                  />
                )}
              />
            </div>

            <div className="from-group">
              <Form.Label>Location*</Form.Label>
              <Controller
                className="Select_Dropdown_holder"
                name="state_id"
                control={control}
                // rules={{ required: "Location is required" }}
                render={({ field }) => (
                  <Select
                    styles={{
                      control: (baseStyles) => ({
                        ...baseStyles,
                        borderColor: errors.state_id ? "red" : baseStyles,
                      }),
                    }}
                    {...field}
                    options={states}
                  />
                )}
              />
            </div>

            <div className="btn_holder">
              <Orange_Btn
                btnText="Show Programs"
                onClick={handleSubmit(onSubmit)}
              />
            </div>

          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Show_Programs_Modal;
